<ul class="skip-links" [ngClass]="{ focussed: focus }">
  <li>
    <a [routerLink]="[]" fragment="contenu" queryParamsHandling="merge" (focus)="focus = true" (blur)="focus = false">Aller au contenu</a>
  </li>
  <li>
    <a [routerLink]="[]" fragment="pied-de-page" queryParamsHandling="merge" (focus)="focus = true" (blur)="focus = false">Aller au pied de page</a>
  </li>
</ul>
